import { BaseRouteService } from 'core/services';

class WarehouseOrganizationInfoRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'warehouse-organization-infos/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	adjustInventory(sourceOfChange) {
		return super.create(this.base + 'adjustment/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}

	closeOutPalletizing(sourceOfChange, warehouseId) {
		return super.update(
			this.base + 'close-out-palletizing/{warehouseId}/?sourceOfChange={sourceOfChange}',
			{ warehouseId },
			{ sourceOfChange }
		);
	}

	closeOutExitScan(sourceOfChange, warehouseId) {
		return super.update(
			this.base + 'close-out-exit-scan/{warehouseId}/?sourceOfChange={sourceOfChange}',
			{ warehouseId },
			{ sourceOfChange }
		);
	}
}

export default WarehouseOrganizationInfoRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/WarehouseOrganizationInfoRouteService.js